<layout-page-container class="overflow-hidden">
  <layout-header-container title="Preisprofile"></layout-header-container>

  <layout-form-container (clear)="newConfigurationName = ''" (submit)="AddConfiguration()"
                         [hasSearch]="false" [permission]="PermissionService.Inventory_ConfigurationBuilder_Add()"
                         clearText="Feld leeren"
                         submitText="Preisprofil anlegen">
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      <div class="sm:col-span-6">
        <label class="block text-sm font-medium leading-6 text-gray-900" for="configuration-name">Name</label>
        <input #name [(ngModel)]="newConfigurationName"
               autocomplete="configuration-name"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
               id="configuration-name" name="configuration-name"
               type="text">
      </div>
    </div>
  </layout-form-container>

  <div class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-x-8">
    <div class="">
      <nav aria-label="Sidebar" class="space-y-1 flex-col">
        <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-50 hover:text-gray-900" -->
        @for (configuration of configurationBuild; track configuration.id) {
          <div class="flex items-center">
            <a (click)="SetActiveConfiguration(configuration)"
               [class.bg-gray-100]="activeConfiguration == configuration"
               [class.text-gray-900]="activeConfiguration == configuration"
               aria-current="page"
               class="w-full hover:bg-gray-50 text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer flex items-center rounded-md px-3 py-2 text-sm font-medium">
              <span class="truncate">{{ configuration.name }}</span>
              <cqme-dropdown class="ml-auto">
                <cqme-dropdown-item (click)="special = configuration.special" label="Einstellungen">
                  <svg class="bi bi-gear-wide-connected w-4" height="16" icon viewBox="0 0 16 16"
                       width="16" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434l.071-.286zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5zm0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78h4.723zM5.048 3.967c-.03.021-.058.043-.087.065l.087-.065zm-.431.355A4.984 4.984 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8 4.617 4.322zm.344 7.646.087.065-.087-.065z"/>
                  </svg>
                </cqme-dropdown-item>
                @if (PermissionService.CheckPermission(PermissionService.Inventory_ConfigurationBuilder_Add())) {
                  <cqme-dropdown-item (click)="CloneConfiguration(configuration)" label="Profil kopieren">
                    <svg class="bi bi-node-plus w-4" height="16" icon viewBox="0 0 16 16"
                         width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025zM11 5a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 11 5zM1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                        fill-rule="evenodd"/>
                    </svg>
                  </cqme-dropdown-item>
                }
                @if (PermissionService.CheckPermission(PermissionService.Inventory_Configuration_Delete())) {
                  <cqme-dropdown-item (click)="RemoveConfiguration(configuration)" label="Profil löschen">
                    <svg class="bi bi-trash3 w-4" height="16" icon viewBox="0 0 16 16" width="16"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                    </svg>
                  </cqme-dropdown-item>
                }
                @if (keyboardService.isOptionPressed) {
                  <cqme-dropdown-item (click)="CopyConfigurationId(configuration)" label="ID kopieren"/>
                }
              </cqme-dropdown>
            </a>
          </div>
        }
      </nav>
    </div>

    @if (activeConfiguration) {
      <div class="col-span-1 lg:col-span-2 xl:col-span-3" id="content">
        <p class="fw-bold text-xl lg:hidden">{{ activeConfiguration.name }}</p>
        <div>
          <div [class.2xl:hidden]="activeConfiguration.tags.length <= 8">
            <label class="sr-only" for="tabs">Select a tag.</label>
            <ng-template #tagTemplate let-tag>
              @if (tag.active) {
                <b class="text-green-700">&check;</b>
              } @else {
                <b class="text-red-600">&cross;</b>
              }
              {{ tag.name }}
            </ng-template>
            <cqme-select [(current)]="activeTag" [labelKey]="'name'" [optionTemplate]="tagTemplate"
                         [options]="activeConfiguration.tags"></cqme-select>
          </div>
          <div [class.2xl:block]="activeConfiguration.tags.length <= 8" class="hidden">
            <nav aria-label="Tabs" class="isolate flex divide-x divide-gray-200 rounded-lg shadow">
              <!-- Current: "text-gray-900", Default: "text-gray-500 hover:text-gray-700" -->
              @for (tag of activeConfiguration.tags; track tag.id) {
                <!-- The deactivated tab swaps its background to gray-300, so the label has to be re-shaded with
                     it: the default text-theme-primary-700 (pink-700, #be185d) measures 4.10:1 on #d1d5db,
                     under WCAG AA's 4.5:1 for text this size. theme-primary-900 measures 6.55:1 — and it is
                     already this tab's own hover shade, so nothing new is introduced. Important, like the
                     !bg-gray-300 it pairs with, because the base class sets the same property.
                     Only reachable at 2xl (the wrapper above is `hidden` until then), which is why every
                     narrower run had this element display:none and axe never judged it. -->
                <a (click)="SetActiveTag(tag)"
                   [class.!bg-gray-300]="!tag.active"
                   [class.!text-theme-primary-900]="!tag.active"
                   [class.line-through]="!tag.active" [class.rounded-l-lg]=""
                   [class.rounded-r-lg]=""
                   [class.text-gray-900]="activeTag?.id == tag.id"
                   aria-current="page"
                   class="text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer group relative min-w-0 flex-1 overflow-hidden bg-white py-3 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10 flex">
                  <span class="truncate text-ellipsis w-full">{{ tag.name }}</span>
                  <span [class.bg-theme-primary-900]="activeTag?.id == tag.id" aria-hidden="true"
                        class="absolute inset-x-0 bottom-0 h-0.5"></span>
                </a>
              }
            </nav>
          </div>
        </div>
        <div *ngIf="activeConfiguration && activeTag" class="pt-2 overflow-x-auto">
          <div class="flex py-3">
            <div class="relative flex items-start">
              <div
                [ngClass]="{'pointer-events-none opacity-50' : !PermissionService.CheckPermission(PermissionService.Inventory_Override_Tag())}"
                class="flex h-6 items-center">
                <!--<input [(ngModel)]="activeTag.active" id="tag_active" (ngModelChange)="ToggleTag(activeConfiguration, activeTag)" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-theme-primary-700 focus:ring-theme-primary-700">-->
                <cqme-checkbox (checkedChange)="ToggleTag(activeConfiguration, activeTag, $event)"
                               [(checked)]="activeTag.active"
                               [disabled]="!PermissionService.CheckPermission(PermissionService.Inventory_Override_Tag())"
                               id="{{activeConfiguration.id}}_{{activeTag.id}}" label="Aktiv"
                               class="pl-2"/>
              </div>
            </div>
          </div>

          <table class="min-w-full divide-y divide-gray-300">
            <thead>
            <tr>
              <th class="" scope="col"></th>
              <th class="py-1.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0" scope="col">Name</th>
              @if (keyboardService.isOptionPressed) {
                <th class="hidden px-3 py-1.5 text-left text-sm font-semibold text-gray-900 xl:table-cell w-full"
                    scope="col">
                  ID
                </th>
              } @else {
                <th class="w-full"></th>
              }
              <th class="px-3 py-1.5 text-left text-sm font-semibold text-gray-900" scope="col">Preis</th>
              <th *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_Override_Composition())"
                  class="relative py-1.5 pl-3 pr-4 sm:pr-0"
                  scope="col">
                <span class="sr-only">Reset</span>
              </th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
            <!--<tr *ngFor="let composition of activeTag.compositions" [class.line-through]="!composition.active">
              <td class="">
                <input [(ngModel)]="composition.active"  (ngModelChange)="ToggleComposition(activeConfiguration, composition)" aria-describedby="comments-description" name="comments" type="checkbox" class="place-self-center h-4 w-4 rounded border-gray-300 text-theme-primary-700 focus:ring-theme-primary-700">
              </td>
              <td class="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{{ composition.name }}</td>
              <td class="hidden whitespace-nowrap px-3 py-3 text-sm text-gray-500 xl:table-cell">{{ composition.id }}</td>
              <td class="whitespace-nowrap px-3 py-3 text-sm text-gray-500">{{ composition.price | currency: "EUR" }}</td>
              <td class="whitespace-nowrap py-3 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                <a href="#" class="text-theme-primary-700 hover:text-indigo-900">Edit<span class="sr-only">, Lindsay Walton</span></a>
              </td>
            </tr>-->
            <tr *ngFor="let composition of activeTag.compositions; let ccIndex = index; TrackBy: TrackByIndex"
                class="hover:bg-gray-100">
              <td class="pl-2">
                <cqme-checkbox (checkedChange)="SetComposition(activeConfiguration, composition, $event, null)"
                               [(checked)]="composition.active"
                               [disabled]="!PermissionService.CheckPermission(PermissionService.Inventory_Override_Composition())"
                               id="{{activeConfiguration.id}}_{{activeTag.id}}_{{composition.id}}"/>
              </td>
              <td [class.line-through]="!composition.active" [class.text-red-600]="composition.special"
                  class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                <label
                  for="{{activeConfiguration.id}}_{{activeTag.id}}_{{composition.id}}">{{ composition.name }}</label>
              </td>
              @if (keyboardService.isOptionPressed) {
                <td [class.line-through]="!composition.active"
                    class="hidden whitespace-nowrap px-3 py-2 text-sm text-gray-500 xl:table-cell">{{ composition.id }}
                </td>
              } @else {
                <td></td>
              }
              <td [class.line-through]="!composition.active"
                  [ngClass]="{'pointer-events-none' : !PermissionService.CheckPermission(PermissionService.Inventory_Override_Composition())}"
                  class="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
              <span *ngIf="composition.price != composition.oPrice || composition.special"
                    [class.text-red-400]="composition.price != composition.oPrice || composition.special">{{ composition.oPrice | currency: "EUR" }}&nbsp;</span>
                <span (click)="OverrideCompositionPrice(activeConfiguration, composition)" *ngIf="!composition.special"
                      [class.line-through]="composition.price != composition.oPrice"
                      class="hover:text-theme-primary-700 cursor-pointer">
                {{ composition.price | currency: "EUR" }}
              </span>
              </td>
              <td *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_Override_Composition())"
                  class="whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-2">
                <a (click)="SetComposition(activeConfiguration, composition)" *ngIf="!composition.special"
                   class="no-underline	cursor-pointer text-yellow-600 hover:text-yellow-900">Reset<span
                  class="sr-only"></span></a>
              </td>
            </tr>
            <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
</layout-page-container>

@if (priceOverrideTarget(); as target) {
  <app-price-input-dialog heading="Preis ändern" label="Neuer Preis in €"
                          [details]="priceOverrideDetails(target)" [initialValue]="target.composition.oPrice"
                          [resetLabel]="HasPriceOverride(target.composition) ? 'Auf Standardpreis zurücksetzen' : null"
                          (saved)="SavePriceOverride(target, $event)" (reset)="ResetPriceOverride(target)"
                          (cancelled)="CancelPriceOverride()"/>
}

<div *ngIf="special" aria-labelledby="modal-title" aria-modal="true" class="relative z-10" role="dialog">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

  <div class="fixed inset-0 z-10 overflow-y-auto lg:pl-72">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div
        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-3 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg sm:p-6">
        <div>
          <div class="grid grid-cols-2 border-b-2 border-gray-400 content-center pb-2">
            <div class="flex">
              <p class="fw-bold text-lg place-self-center">Special Konfiguration</p>
            </div>
          </div>
        </div>
        <!-- todo check permissions -->
        <div
          [ngClass]="{'!pointer-events-none !cursor-normal': !PermissionService.CheckPermission(PermissionService.Inventory_ConfigurationBuilder_SetSpecial())}"
          class="grid grid-cols-1 pt-2 gap-2">
          <div class="flex mt-3">
            <!-- Enabled: "bg-theme-primary-700", Not Enabled: "bg-gray-200" -->
            <button (click)="special.active = !special.active" [class.!bg-theme-primary-700]="special.active"
                    aria-checked="false"
                    aria-labelledby="annual-billing-label"
                    class="bg-gray-200 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-theme-primary-700 focus:ring-offset-2"
                    role="switch" type="button">
              <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
              <span [class.!translate-x-5]="special.active" aria-hidden="true"
                    class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
            </button>
            <span class="ml-3 text-sm" id="SpecialToggle">
              <span class="font-medium text-gray-900">Aktiviert</span>
            </span>
          </div>
          <div>
            <div class="mt-2 flex rounded-md shadow-sm">
              <span
                class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 px-3 text-gray-500 sm:text-sm">Name</span>
              <input [(ngModel)]="special.name"
                     class="block w-full min-w-0 flex-1 rounded-none rounded-r-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 px-2"
                     id="special_name" name="special_name"
                     placeholder="Name"
                     type="text">
            </div>
          </div>
          <div>
            <div class="mt-2 flex rounded-md shadow-sm">
              <span
                class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 px-3 text-gray-500 sm:text-sm">Farbe</span>
              <input (ngModelChange)="SetSpecialColor($event)" [ngModel]="'#' + special.color"
                     class="block w-full min-w-0 flex-1 rounded-none rounded-r-md border-0 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                     id="special_color" name="special_color"
                     type="color">
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid grid-cols-1 sm:grid-cols-2 sm:gap-3">
          <button (click)="special = undefined"
                  class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0"
                  type="button">
            Abbrechen
          </button>
          <button
            (click)="ConfigureSpecial(special!)"
            *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_ConfigurationBuilder_SetSpecial())"
            class="mt-2 sm:!mt-0 inline-flex w-full justify-center rounded-md bg-theme-primary-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700"
            type="button">
            Speichern
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
